import clsx, { type ClassValue } from 'clsx';

/**
 * Thin wrapper around clsx — keeps the dependency import local so downstream
 * packages can `import { cx } from '@emailforge/ui'` without adding clsx themselves.
 */
export function cx(...inputs: ClassValue[]): string {
  return clsx(...inputs);
}
